import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getPrivacyPolicyByCountry } from './PrivacyPolicyUtils';

const privacyPolicyContentsOuterDivStyle = {
    maxWidth: '800px',
    top: '45%',
    transform: 'translate(0%,-45%)',
    overflow: 'hidden',
    height: 'max-content',
};

const PrivacyPolicyFooter = (props) => {
    const [privacyPolicyPopUpVisible, setPrivacyPolicyPopupVisibility] =
        useState(false);

    const privacyPolicy = getPrivacyPolicyByCountry(props.country);

    const _renderPrivacyPolicyOverlay = () => (
        <div>
            <div
                className="text-left fixed top-0 left-0 w-full h-screen flex item-center justify-center z-10"
                style={{ backgroundColor: '#00000087' }}
            >
                <div
                    className="relative bg-white w-4/5 mx-auto rounded min-h-0"
                    style={privacyPolicyContentsOuterDivStyle}
                >
                    <div
                        className="text-blue-700 font-semibold py-4 text-lg px-4 bg-blue-100  border border-gray-200"
                        data-testid="privacy-notice-popup"
                    >
                        Privacy Notice
                        <span
                            className="cursor-pointer float-right px-2 "
                            onClick={() =>
                                setPrivacyPolicyPopupVisibility(false)
                            }
                            data-testid="close-privacy-notice"
                        >
                            X
                        </span>
                    </div>
                    <div
                        className={
                            'text-gray-900 px-6 py-2 justify-evenly overflow-auto h-96 text-sm md:text-md'
                        }
                    >
                        {privacyPolicy.element}
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="text-center md:justify-item-center w-full bg-blue-600 max-w-6xl px-4 lg:px-0 mx-auto text-white py-2 mt-10 md:mt-15">
            {privacyPolicyPopUpVisible && _renderPrivacyPolicyOverlay()}
            <div className={'text-center'}>
                Read our privacy notice{' '}
                <button
                    onClick={() => setPrivacyPolicyPopupVisibility(true)}
                    className={'underline'}
                    data-testid="open-privacy-notice-popup"
                >
                    here
                </button>
                .
            </div>
        </div>
    );
};

PrivacyPolicyFooter.propTypes = {
    country: PropTypes.string,
};

export default PrivacyPolicyFooter;
